import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from './modules/prime-ng/prime-ng.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './modules/shared/shared.module';

import { HttpClient, HttpClientModule } from '@angular/common/http';

import '@angular/compiler';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DialogService } from 'primeng/dynamicdialog';
import { JwtModule } from '@auth0/angular-jwt';
import { AuthGuard } from './guard/guard.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ResyModule } from './modules/resy/resy-module';
import { environment } from "../environments/environment";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { AngularFireAnalyticsModule } from "@angular/fire/compat/analytics";
import { GoogleMapsModule } from '@angular/google-maps';

// Http Loader for ngx-translate
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    DragDropModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    InfiniteScrollModule,
    PrimeNgModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    NgImageFullscreenViewModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    GoogleMapsModule,
   /* AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDySCASHdVWlvrUOWD1nb41QKi7FLaATo4',
      libraries: ["places"]
    }),*/
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: createTranslateLoader
      }
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem("resy_access_token");
        },
      },
    }),
    ResyModule
  ],
  exports: [],
  providers: [DialogService, AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }
